const AdminProjectTypes = {
    Diagnostics: 0,
    Jobmatch: 2,
    P360: 360,
    Survey: 4,
} as const;

export type AdminProjectType =
    | typeof AdminProjectTypes.Diagnostics
    | typeof AdminProjectTypes.Jobmatch
    | typeof AdminProjectTypes.P360
    | typeof AdminProjectTypes.Survey;

export default AdminProjectTypes;
